import { buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TimeBasedn2y4mla0fo0k as TimeBased,
  DateBasedu1hioe8kvjhw as DateBased,
  DayBased28hvf1xjg5r93 as DayBased,
  MonthBased16lxw4e6nhntg as MonthBased,
  DateTimeUnit3ugctnw90699o as DateTimeUnit,
} from '../DateTimeUnit.mjs';
import {
  MissingFieldException24tqif29emcmi as MissingFieldException,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { SealedClassSerializeriwipiibk55zc as SealedClassSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SealedSerializer.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
  return buildClassSerialDescriptor('kotlinx.datetime.TimeBased', [], TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
}
function TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
  // Inline function 'kotlinx.serialization.descriptors.element' call
  var elementName = 'nanoseconds';
  var annotations = emptyList();
  // Inline function 'kotlinx.serialization.serializer' call
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_0 = serializer(createKType(PrimitiveClasses_getInstance().get_longClass_a79cj7_k$(), arrayOf([]), false));
  var descriptor = (isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE()).get_descriptor_wjt6a0_k$();
  $this$buildClassSerialDescriptor.element_om879h_k$(elementName, descriptor, annotations, false);
  return Unit_instance;
}
function TimeBasedDateTimeUnitSerializer$_get_descriptor_$ref_ezonyw() {
  return constructCallableReference((p0) => p0.get_descriptor_wjt6a0_k$(), 1, 0, 65);
}
var TimeBasedDateTimeUnitSerializerClass;
function TimeBasedDateTimeUnitSerializer() {
  if (TimeBasedDateTimeUnitSerializerClass === VOID) {
    class $ {
      constructor() {
        TimeBasedDateTimeUnitSerializer_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.descriptor$delegate_1 = lazy(tmp_0, TimeBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
      }
      get_descriptor_wjt6a0_k$() {
        var tmp0 = this.descriptor$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, TimeBasedDateTimeUnitSerializer$_get_descriptor_$ref_ezonyw(), null);
        return tmp0.get_value_j01efc_k$();
      }
      serialize_45e5yg_k$(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.get_descriptor_wjt6a0_k$();
        var composite = encoder.beginStructure_yljocp_k$(descriptor);
        composite.encodeLongElement_ovnxxh_k$(TimeBasedDateTimeUnitSerializer_getInstance().get_descriptor_wjt6a0_k$(), 0, value.nanoseconds_1);
        composite.endStructure_1xqz0n_k$(descriptor);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_45e5yg_k$(encoder, value instanceof TimeBased() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var seen = {_v: false};
        var nanoseconds = {_v: 0n};
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.get_descriptor_wjt6a0_k$();
        var composite = decoder.beginStructure_yljocp_k$(descriptor);
        if (composite.decodeSequentially_xlblqy_k$()) {
          nanoseconds._v = composite.decodeLongElement_994anb_k$(TimeBasedDateTimeUnitSerializer_getInstance().get_descriptor_wjt6a0_k$(), 0);
          seen._v = true;
        } else {
          loop: while (true) {
            var elementIndex = composite.decodeElementIndex_bstkhp_k$(TimeBasedDateTimeUnitSerializer_getInstance().get_descriptor_wjt6a0_k$());
            switch (elementIndex) {
              case 0:
                nanoseconds._v = composite.decodeLongElement_994anb_k$(TimeBasedDateTimeUnitSerializer_getInstance().get_descriptor_wjt6a0_k$(), 0);
                seen._v = true;
                break;
              case -1:
                break loop;
              default:
                throwUnknownIndexException(elementIndex);
                break;
            }
          }
        }
        var result = Unit_instance;
        composite.endStructure_1xqz0n_k$(descriptor);
        if (!seen._v)
          throw MissingFieldException().new_kotlinx_serialization_MissingFieldException_r3nret_k$('nanoseconds', this.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
        return new (TimeBased())(nanoseconds._v);
      }
    }
    initMetadataForObject($, 'TimeBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer()]);
    TimeBasedDateTimeUnitSerializerClass = $;
  }
  return TimeBasedDateTimeUnitSerializerClass;
}
var TimeBasedDateTimeUnitSerializer_instance;
function TimeBasedDateTimeUnitSerializer_getInstance() {
  if (TimeBasedDateTimeUnitSerializer_instance === VOID)
    new (TimeBasedDateTimeUnitSerializer())();
  return TimeBasedDateTimeUnitSerializer_instance;
}
function _get_impl__d88w17($this) {
  var tmp0 = $this.impl$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('impl', 1, tmp, DateBasedDateTimeUnitSerializer$_get_impl_$ref_m860rs(), null);
  return tmp0.get_value_j01efc_k$();
}
function DateBasedDateTimeUnitSerializer$impl$delegate$lambda() {
  var tmp = getKClass(DateBased());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(DayBased()), getKClass(MonthBased())];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [DayBasedDateTimeUnitSerializer_getInstance(), MonthBasedDateTimeUnitSerializer_getInstance()];
  return SealedClassSerializer().new_kotlinx_serialization_SealedClassSerializer_2qsta_k$('kotlinx.datetime.DateTimeUnit.DateBased', tmp, tmp_0, tmp$ret$3);
}
function DateBasedDateTimeUnitSerializer$_get_impl_$ref_m860rs() {
  return constructCallableReference((p0) => _get_impl__d88w17(p0), 1, 0, 66);
}
var DateBasedDateTimeUnitSerializerClass;
function DateBasedDateTimeUnitSerializer() {
  if (DateBasedDateTimeUnitSerializerClass === VOID) {
    class $ extends AbstractPolymorphicSerializer() {
      constructor() {
        return new.target.new_kotlinx_datetime_serializers_DateBasedDateTimeUnitSerializer_6q04nv_k$();
      }
      static new_kotlinx_datetime_serializers_DateBasedDateTimeUnitSerializer_6q04nv_k$() {
        DateBasedDateTimeUnitSerializer_instance = null;
        var $this = this.new_kotlinx_serialization_internal_AbstractPolymorphicSerializer_mpc34r_k$();
        DateBasedDateTimeUnitSerializer_instance = $this;
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.impl$delegate_1 = lazy(tmp_0, DateBasedDateTimeUnitSerializer$impl$delegate$lambda);
        return $this;
      }
      findPolymorphicSerializerOrNull_o3cszk_k$(decoder, klassName) {
        return _get_impl__d88w17(this).findPolymorphicSerializerOrNull_o3cszk_k$(decoder, klassName);
      }
      findPolymorphicSerializerOrNull_2e74cw_k$(encoder, value) {
        return _get_impl__d88w17(this).findPolymorphicSerializerOrNull_sqpvzc_k$(encoder, value);
      }
      findPolymorphicSerializerOrNull_sqpvzc_k$(encoder, value) {
        return this.findPolymorphicSerializerOrNull_2e74cw_k$(encoder, value instanceof DateBased() ? value : THROW_CCE());
      }
      get_baseClass_lygw3m_k$() {
        return getKClass(DateBased());
      }
      get_descriptor_wjt6a0_k$() {
        return _get_impl__d88w17(this).get_descriptor_wjt6a0_k$();
      }
    }
    initMetadataForObject($, 'DateBasedDateTimeUnitSerializer');
    DateBasedDateTimeUnitSerializerClass = $;
  }
  return DateBasedDateTimeUnitSerializerClass;
}
var DateBasedDateTimeUnitSerializer_instance;
function DateBasedDateTimeUnitSerializer_getInstance() {
  if (DateBasedDateTimeUnitSerializer_instance === VOID)
    DateBasedDateTimeUnitSerializer().new_kotlinx_datetime_serializers_DateBasedDateTimeUnitSerializer_6q04nv_k$();
  return DateBasedDateTimeUnitSerializer_instance;
}
function DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
  return buildClassSerialDescriptor('kotlinx.datetime.DayBased', [], DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
}
function DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
  // Inline function 'kotlinx.serialization.descriptors.element' call
  var annotations = emptyList();
  // Inline function 'kotlinx.serialization.serializer' call
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_0 = serializer(createKType(PrimitiveClasses_getInstance().get_intClass_mw4y9a_k$(), arrayOf([]), false));
  var descriptor = (isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE()).get_descriptor_wjt6a0_k$();
  $this$buildClassSerialDescriptor.element_om879h_k$('days', descriptor, annotations, false);
  return Unit_instance;
}
function DayBasedDateTimeUnitSerializer$_get_descriptor_$ref_2ycvl3() {
  return constructCallableReference((p0) => p0.get_descriptor_wjt6a0_k$(), 1, 0, 67);
}
var DayBasedDateTimeUnitSerializerClass;
function DayBasedDateTimeUnitSerializer() {
  if (DayBasedDateTimeUnitSerializerClass === VOID) {
    class $ {
      constructor() {
        DayBasedDateTimeUnitSerializer_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.descriptor$delegate_1 = lazy(tmp_0, DayBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
      }
      get_descriptor_wjt6a0_k$() {
        var tmp0 = this.descriptor$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, DayBasedDateTimeUnitSerializer$_get_descriptor_$ref_2ycvl3(), null);
        return tmp0.get_value_j01efc_k$();
      }
      serialize_tfoyka_k$(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.get_descriptor_wjt6a0_k$();
        var composite = encoder.beginStructure_yljocp_k$(descriptor);
        composite.encodeIntElement_krhhce_k$(DayBasedDateTimeUnitSerializer_getInstance().get_descriptor_wjt6a0_k$(), 0, value.days_1);
        composite.endStructure_1xqz0n_k$(descriptor);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_tfoyka_k$(encoder, value instanceof DayBased() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var seen = {_v: false};
        var days = {_v: 0};
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.get_descriptor_wjt6a0_k$();
        var composite = decoder.beginStructure_yljocp_k$(descriptor);
        if (composite.decodeSequentially_xlblqy_k$()) {
          days._v = composite.decodeIntElement_941u6a_k$(DayBasedDateTimeUnitSerializer_getInstance().get_descriptor_wjt6a0_k$(), 0);
          seen._v = true;
        } else {
          loop: while (true) {
            var elementIndex = composite.decodeElementIndex_bstkhp_k$(DayBasedDateTimeUnitSerializer_getInstance().get_descriptor_wjt6a0_k$());
            switch (elementIndex) {
              case 0:
                days._v = composite.decodeIntElement_941u6a_k$(DayBasedDateTimeUnitSerializer_getInstance().get_descriptor_wjt6a0_k$(), 0);
                seen._v = true;
                break;
              case -1:
                break loop;
              default:
                throwUnknownIndexException(elementIndex);
                break;
            }
          }
        }
        var result = Unit_instance;
        composite.endStructure_1xqz0n_k$(descriptor);
        if (!seen._v)
          throw MissingFieldException().new_kotlinx_serialization_MissingFieldException_r3nret_k$('days', this.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
        return new (DayBased())(days._v);
      }
    }
    initMetadataForObject($, 'DayBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer()]);
    DayBasedDateTimeUnitSerializerClass = $;
  }
  return DayBasedDateTimeUnitSerializerClass;
}
var DayBasedDateTimeUnitSerializer_instance;
function DayBasedDateTimeUnitSerializer_getInstance() {
  if (DayBasedDateTimeUnitSerializer_instance === VOID)
    new (DayBasedDateTimeUnitSerializer())();
  return DayBasedDateTimeUnitSerializer_instance;
}
function MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda() {
  return buildClassSerialDescriptor('kotlinx.datetime.MonthBased', [], MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda);
}
function MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda$lambda($this$buildClassSerialDescriptor) {
  // Inline function 'kotlinx.serialization.descriptors.element' call
  var annotations = emptyList();
  // Inline function 'kotlinx.serialization.serializer' call
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_0 = serializer(createKType(PrimitiveClasses_getInstance().get_intClass_mw4y9a_k$(), arrayOf([]), false));
  var descriptor = (isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE()).get_descriptor_wjt6a0_k$();
  $this$buildClassSerialDescriptor.element_om879h_k$('months', descriptor, annotations, false);
  return Unit_instance;
}
function MonthBasedDateTimeUnitSerializer$_get_descriptor_$ref_vroatn() {
  return constructCallableReference((p0) => p0.get_descriptor_wjt6a0_k$(), 1, 0, 68);
}
var MonthBasedDateTimeUnitSerializerClass;
function MonthBasedDateTimeUnitSerializer() {
  if (MonthBasedDateTimeUnitSerializerClass === VOID) {
    class $ {
      constructor() {
        MonthBasedDateTimeUnitSerializer_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.descriptor$delegate_1 = lazy(tmp_0, MonthBasedDateTimeUnitSerializer$descriptor$delegate$lambda);
      }
      get_descriptor_wjt6a0_k$() {
        var tmp0 = this.descriptor$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, MonthBasedDateTimeUnitSerializer$_get_descriptor_$ref_vroatn(), null);
        return tmp0.get_value_j01efc_k$();
      }
      serialize_4f5fti_k$(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.get_descriptor_wjt6a0_k$();
        var composite = encoder.beginStructure_yljocp_k$(descriptor);
        composite.encodeIntElement_krhhce_k$(MonthBasedDateTimeUnitSerializer_getInstance().get_descriptor_wjt6a0_k$(), 0, value.months_1);
        composite.endStructure_1xqz0n_k$(descriptor);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_4f5fti_k$(encoder, value instanceof MonthBased() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var seen = {_v: false};
        var months = {_v: 0};
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.get_descriptor_wjt6a0_k$();
        var composite = decoder.beginStructure_yljocp_k$(descriptor);
        if (composite.decodeSequentially_xlblqy_k$()) {
          months._v = composite.decodeIntElement_941u6a_k$(MonthBasedDateTimeUnitSerializer_getInstance().get_descriptor_wjt6a0_k$(), 0);
          seen._v = true;
        } else {
          loop: while (true) {
            var elementIndex = composite.decodeElementIndex_bstkhp_k$(MonthBasedDateTimeUnitSerializer_getInstance().get_descriptor_wjt6a0_k$());
            switch (elementIndex) {
              case 0:
                months._v = composite.decodeIntElement_941u6a_k$(MonthBasedDateTimeUnitSerializer_getInstance().get_descriptor_wjt6a0_k$(), 0);
                seen._v = true;
                break;
              case -1:
                break loop;
              default:
                throwUnknownIndexException(elementIndex);
                break;
            }
          }
        }
        var result = Unit_instance;
        composite.endStructure_1xqz0n_k$(descriptor);
        if (!seen._v)
          throw MissingFieldException().new_kotlinx_serialization_MissingFieldException_r3nret_k$('months', this.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
        return new (MonthBased())(months._v);
      }
    }
    initMetadataForObject($, 'MonthBasedDateTimeUnitSerializer', VOID, VOID, [KSerializer()]);
    MonthBasedDateTimeUnitSerializerClass = $;
  }
  return MonthBasedDateTimeUnitSerializerClass;
}
var MonthBasedDateTimeUnitSerializer_instance;
function MonthBasedDateTimeUnitSerializer_getInstance() {
  if (MonthBasedDateTimeUnitSerializer_instance === VOID)
    new (MonthBasedDateTimeUnitSerializer())();
  return MonthBasedDateTimeUnitSerializer_instance;
}
function _get_impl__d88w17_0($this) {
  var tmp0 = $this.impl$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('impl', 1, tmp, DateTimeUnitSerializer$_get_impl_$ref_2y1hvx(), null);
  return tmp0.get_value_j01efc_k$();
}
function DateTimeUnitSerializer$impl$delegate$lambda() {
  var tmp = getKClass(DateTimeUnit());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(DayBased()), getKClass(MonthBased()), getKClass(TimeBased())];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [DayBasedDateTimeUnitSerializer_getInstance(), MonthBasedDateTimeUnitSerializer_getInstance(), TimeBasedDateTimeUnitSerializer_getInstance()];
  return SealedClassSerializer().new_kotlinx_serialization_SealedClassSerializer_2qsta_k$('kotlinx.datetime.DateTimeUnit', tmp, tmp_0, tmp$ret$3);
}
function DateTimeUnitSerializer$_get_impl_$ref_2y1hvx() {
  return constructCallableReference((p0) => _get_impl__d88w17_0(p0), 1, 0, 69);
}
var DateTimeUnitSerializerClass;
function DateTimeUnitSerializer() {
  if (DateTimeUnitSerializerClass === VOID) {
    class $ extends AbstractPolymorphicSerializer() {
      constructor() {
        return new.target.new_kotlinx_datetime_serializers_DateTimeUnitSerializer_qfh78_k$();
      }
      static new_kotlinx_datetime_serializers_DateTimeUnitSerializer_qfh78_k$() {
        DateTimeUnitSerializer_instance = null;
        var $this = this.new_kotlinx_serialization_internal_AbstractPolymorphicSerializer_mpc34r_k$();
        DateTimeUnitSerializer_instance = $this;
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.impl$delegate_1 = lazy(tmp_0, DateTimeUnitSerializer$impl$delegate$lambda);
        return $this;
      }
      findPolymorphicSerializerOrNull_o3cszk_k$(decoder, klassName) {
        return _get_impl__d88w17_0(this).findPolymorphicSerializerOrNull_o3cszk_k$(decoder, klassName);
      }
      findPolymorphicSerializerOrNull_cigpgf_k$(encoder, value) {
        return _get_impl__d88w17_0(this).findPolymorphicSerializerOrNull_sqpvzc_k$(encoder, value);
      }
      findPolymorphicSerializerOrNull_sqpvzc_k$(encoder, value) {
        return this.findPolymorphicSerializerOrNull_cigpgf_k$(encoder, value instanceof DateTimeUnit() ? value : THROW_CCE());
      }
      get_baseClass_lygw3m_k$() {
        return getKClass(DateTimeUnit());
      }
      get_descriptor_wjt6a0_k$() {
        return _get_impl__d88w17_0(this).get_descriptor_wjt6a0_k$();
      }
    }
    initMetadataForObject($, 'DateTimeUnitSerializer');
    DateTimeUnitSerializerClass = $;
  }
  return DateTimeUnitSerializerClass;
}
var DateTimeUnitSerializer_instance;
function DateTimeUnitSerializer_getInstance() {
  if (DateTimeUnitSerializer_instance === VOID)
    DateTimeUnitSerializer().new_kotlinx_datetime_serializers_DateTimeUnitSerializer_qfh78_k$();
  return DateTimeUnitSerializer_instance;
}
function throwUnknownIndexException(index) {
  throw SerializationException().new_kotlinx_serialization_SerializationException_jj1itu_k$('An unknown field for index ' + index);
}
//region block: exports
export {
  DateBasedDateTimeUnitSerializer_getInstance as DateBasedDateTimeUnitSerializer_getInstance1akx7bb1vxf8c,
  DateTimeUnitSerializer_getInstance as DateTimeUnitSerializer_getInstance4ttb7w16orlx,
  DayBasedDateTimeUnitSerializer_getInstance as DayBasedDateTimeUnitSerializer_getInstance1xxpx4q7emkpv,
  MonthBasedDateTimeUnitSerializer_getInstance as MonthBasedDateTimeUnitSerializer_getInstance3dqgiv5zfsawe,
  TimeBasedDateTimeUnitSerializer_getInstance as TimeBasedDateTimeUnitSerializer_getInstance1xwms177r5lzr,
};
//endregion

//# sourceMappingURL=DateTimeUnitSerializers.mjs.map
